import { useMutation } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { toast } from "sonner";
import { TC } from "../utils/trustCallApi";
import type { AdHocScanResult } from "../types";

export function useAdHocScan() {
  const scan = useMutation({
    mutationFn: (phoneNumbers: string): Promise<AdHocScanResult[]> =>
      callApi(TC.PHONES_SCAN, HttpMethod.POST, { phoneNumbers }),
    onError: (error: Error) =>
      toast.error(error.message || "Failed to perform ad-hoc scan"),
  });

  return { scan };
}
